const Styles = () => ({
  backdrop: {
    zIndex: '999',
    color: '#fff',
  },
});

export default Styles;
